module.exports = __webpack_public_path__ + "img/person-icon.f8d5ee74.svg";